import Vue from "vue";
import formatDistance from "date-fns/formatDistance";

// Filters
Vue.filter("formatDateDistance", value => {
  if (!value) return "";

  return formatDistance(new Date(value), new Date(), {
    addSuffix: true
  });
});

Vue.filter("formatPrice", function(value) {
  if (!value) return "free";
  value = value.toString();
  return `$${value}`;
});
